import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Logo } from "../components/Brand";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && user) navigate("/admin", { replace: true });
  }, [user, loading, navigate]);

  const signIn = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="relative hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1640693316735-3fe5ee2de856?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#061224] via-[#0A0A0A]/60 to-transparent" />
        <div className="absolute bottom-12 left-12">
          <h2 className="font-display text-6xl leading-none">
            BUILT FOR
            <br />
            <span className="text-[#FF5A00]">THE NEXT LEVEL</span>
          </h2>
        </div>
      </div>

      <div className="flex items-center justify-center px-6 py-20 grain relative">
        <div className="w-full max-w-md">
          <Logo className="h-24" />
          <p className="label-mono text-[#FF5A00] mt-8">Admin Access</p>
          <h1 className="font-display text-5xl sm:text-6xl leading-none mt-2">
            Athlete Management
          </h1>
          <p className="text-sm text-zinc-400 mt-5 leading-relaxed">
            Owner-only management area. Sign in with Google to add athletes, upload media links and
            publish shareable recruiting profiles.
          </p>
          <button
            data-testid="google-signin-btn"
            onClick={signIn}
            className="mt-10 w-full clip-slant bg-[#FF5A00] hover:bg-[#FF7B33] transition-colors py-4 text-sm font-bold uppercase tracking-[0.2em]"
          >
            Continue with Google
          </button>
        </div>
      </div>
    </div>
  );
}
